import { FILTER_NAME_SUB_MENU } from '../../../constants/filter'

import { SEARCH_RESULTS_POSTS_FILTER_SUB_MENU } from './SearchResultsPosts.constants'

export function getSearchResultsPostsPermanentFilters() {
  return {
    [FILTER_NAME_SUB_MENU]: SEARCH_RESULTS_POSTS_FILTER_SUB_MENU,
  }
}

export function parseSearchResultsPostsPermanentFilters(filters) {
  return [[FILTER_NAME_SUB_MENU, filters[FILTER_NAME_SUB_MENU]]]
}

export function getShowEmptyListRules(items, loading) {
  return !loading && items?.length === 0
}
